export default __webpack_public_path__ + "static/media/player-restrictions.f6b527b5.svg";